/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the InternalAdminReactionsEmojiDefinitionRequestV4 interface.
 */
export function instanceOfInternalAdminReactionsEmojiDefinitionRequestV4(value) {
    return true;
}
export function InternalAdminReactionsEmojiDefinitionRequestV4FromJSON(json) {
    return InternalAdminReactionsEmojiDefinitionRequestV4FromJSONTyped(json, false);
}
export function InternalAdminReactionsEmojiDefinitionRequestV4FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'shortcode': json['shortcode'] == null ? undefined : json['shortcode'],
        'unicode': json['unicode'] == null ? undefined : json['unicode'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'skinToneAllowed': json['skin_tone_allowed'] == null ? undefined : json['skin_tone_allowed'],
        'rowOrder': json['row_order'] == null ? undefined : json['row_order'],
        'variants': json['variants'] == null ? undefined : json['variants'],
    };
}
export function InternalAdminReactionsEmojiDefinitionRequestV4ToJSON(json) {
    return InternalAdminReactionsEmojiDefinitionRequestV4ToJSONTyped(json, false);
}
export function InternalAdminReactionsEmojiDefinitionRequestV4ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'shortcode': value['shortcode'],
        'unicode': value['unicode'],
        'enabled': value['enabled'],
        'skin_tone_allowed': value['skinToneAllowed'],
        'row_order': value['rowOrder'],
        'variants': value['variants'],
    };
}
